import "./MinusIcon.scss"

export const MinusIcon = ({ color, marginToTop = 0 }) => (
  <span className={`MinusIcon MinusIcon__margin-top-${marginToTop} MinusIcon__color-${color}`}>&minus;</span>
);
